import { createAsyncThunk } from '@reduxjs/toolkit';


interface tokenParams {
  otp:string;
  email:string;
}

interface tokenParams2 {
  otp:string;
  email:string;
  slug:string;
}


export interface TokenPayload {
  status: string;
  message: string;
  action:string;
  data:{
    token:string;
    slug: string;
  }
}

export interface TokenPay{
  status:string;
  message:string;
  data:{
      token:string;
      recommendation_id:string;
      reviewer: {
         name: string;
         positions:string;
         picture: string;
    }

  }
}




export const receiveToken = createAsyncThunk<TokenPayload, tokenParams, { rejectValue: string }>(
  'user-verify',
  async ({ otp,email }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}user-verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ otp,email }),
      });

      const responseData:TokenPayload = await response.json();

      if (!response.ok) {
           const errorMessage = responseData.message || "An unknown error occurred";
           throw new Error(errorMessage);
      }
        
      return responseData;

    } catch (error: any) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  }
);


export const tempToken = createAsyncThunk<TokenPay, tokenParams2, { rejectValue: string }>(
  'user-verify-recm',
  async ({ otp,email,slug }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}user-verify-recm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ otp,email,slug }),
      });

      const responseData:TokenPay = await response.json();

      if (!response.ok) {
           const errorMessage = responseData.message || "An unknown error occurred";
           throw new Error(errorMessage);
      }
        
      return responseData;

    } catch (error: any) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  }
);

